import * as React from 'react';
import comparisonLogo from '../../../../../assets/images/comparison.png';

const CompareLogo = () => (
    <img src={comparisonLogo} alt="Core Logo" width="16" height="16" />
);

export default CompareLogo;
